import Vue from 'vue';
import { mapGetters } from 'vuex';
import $ from 'jquery';
import Data from 'src/utils/data';
import HelpIcon from './HelpIcon.vue';
import Util from 'src/utils/general';
import ExcerptsBase from 'src/components/project/analysis/results/widgets/ExcerptsBase.vue';
import Modal from 'src/components/widgets/Modal.vue';
import { Select, Option } from 'element-ui';
import FormatUtils from 'src/utils/formatters';
import Project from 'src/api/project';
import locale from 'element-ui/lib/locale/lang/en';
locale.el.pagination.pagesize = '';
export default Vue.extend({
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    components: { HelpIcon, Modal, Select, Option },
    extends: ExcerptsBase,
    props: {
        /** Allow concept highlighting to be toggled */
        allowHighlightToggle: { type: Boolean, default: true },
        helpIcon: { type: Boolean, default: true },
        initialHits: { type: Object, default: null },
        preview: { type: Boolean, default: true },
        hideExcerptsPerPage: { type: Boolean, default: false },
        header: { type: Boolean, default: true },
        numExcerpts: { type: Number, default: 50 },
        subtext: { type: Boolean, default: true }
    },
    data() {
        return {
            hitsPerPage: this.numExcerpts,
            pageNumber: 1,
            goToPage: 1,
            sentimentValues: [
                { value: 'positive', label: 'Positive' },
                { value: 'negative', label: 'Negative' },
                { value: 'mixed', label: 'Mixed' },
                { value: 'neutral', label: 'Neutral' },
            ]
        };
    },
    computed: {
        ...mapGetters([
            'currentModel', 'hasSentiment', 'currentAnalysis', 'featureFlags', 'currentProject', 'currentSite'
        ]),
        showAnnotations() {
            return this.currentProject?.show_verbatim_annotations;
        },
        invisPrefix() {
            return Data.INVISIBLE_PREFIX;
        },
        numberOfPages() {
            return Math.ceil(this.count / this.hitsPerPage);
        },
        paginationRange() {
            return Util.pagination(this.pageNumber, this.numberOfPages);
        },
        countExcerpts() {
            return this.count / (this.currentModel.stats.n_frames - this.currentModel.stats.empty_frames);
        }
    },
    watch: {
        'query': {
            handler: function (val) {
                if (val) {
                    // Clear this existing hits first
                    this.getExcerpts(val, 0, this.hitsPerPage, true);
                }
            },
            immediate: true
        },
        'hitsPerPage': function (val) {
            this.loadPageExcerpts(1);
            this.$analytics.track.verbatimsWidget.changePageLimit(false, val);
        },
        isHighlighted: function (val) {
            this.$analytics.track.verbatimsWidget.toggleHighlight(false, val);
        }
    },
    mounted() {
        this.$nextTick(() => {
            $('.ui.dropdown.num-pages-select').dropdown({
                onChange: (v) => {
                    this.hitsPerPage = v;
                }
            });
        });
    },
    methods: {
        async changeSentiment(hit) {
            this.isLoading = true;
            try {
                await Project.changeSentiment(this.currentProject.chrysalis_ref, this.currentSite.chrysalis_url, this.currentProject.id, hit._id, hit._attributes.sentiment);
            }
            finally {
                this.isLoading = false;
                this.$analytics.track.verbatimsWidget.updateSentiment(this.currentProject.id, hit._attributes.sentiment);
            }
        },
        number: FormatUtils.number,
        async loadPageFromModal(page) {
            if (!await this.$validator.validateAll()) {
                return;
            }
            this.loadPageExcerpts(page);
            this.$refs.jumpToPageModal.hide();
        },
        loadPageExcerpts(page, modal) {
            // Pop the page select modal if the passed value is the elipsis
            if (page === '...') {
                this.$refs.jumpToPageModal.show();
            }
            else {
                // Now the value has to be an int, we should parse it to one to avoid accidental concatenations
                page = parseInt(page);
                if (page > 0 && page <= this.numberOfPages) {
                    this.pageNumber = page;
                    let start = this._pageToRange(page);
                    this.getExcerpts(this.query, start, this.hitsPerPage, true);
                }
            }
        },
        showInfo(hit) {
            hit._show_info = !hit._show_info;
            if (hit._show_info) {
                this.$analytics.track.verbatimsWidget.showInfo(false);
            }
        },
        _pageToRange(page) {
            const index = (page * this.hitsPerPage) - this.hitsPerPage;
            this.$analytics.track.verbatimsWidget.paginate(false, this.hitsPerPage, index);
            return index;
        }
    }
});
